export default {
    bleedByDefault: true,
    debug: false
}